const COLUMN_VISIBILITY_STORAGE_KEY = 'quoteColumnVisibility'

export interface ColumnVisibilityState {
	[quoteId: string]: Record<string, boolean>
}

/**
 * Get column visibility state for a specific quote ID from localStorage
 */
export const getColumnVisibilityForQuote = (
	quoteId: string
): Record<string, boolean> => {
	try {
		const storedData = localStorage.getItem(COLUMN_VISIBILITY_STORAGE_KEY)
		if (!storedData) {
			return {}
		}

		const allColumnVisibility: ColumnVisibilityState =
			JSON.parse(storedData)
		return allColumnVisibility[quoteId] || {}
	} catch (error) {
		console.error(
			'Error reading column visibility from localStorage:',
			error
		)
		return {}
	}
}

/**
 * Save column visibility state for a specific quote ID to localStorage
 */
export const saveColumnVisibilityForQuote = (
	quoteId: string,
	columnVisibility: Record<string, boolean>
): void => {
	try {
		const storedData = localStorage.getItem(COLUMN_VISIBILITY_STORAGE_KEY)
		let allColumnVisibility: ColumnVisibilityState = {}

		if (storedData) {
			allColumnVisibility = JSON.parse(storedData)
		}

		allColumnVisibility[quoteId] = columnVisibility
		localStorage.setItem(
			COLUMN_VISIBILITY_STORAGE_KEY,
			JSON.stringify(allColumnVisibility)
		)
	} catch (error) {
		console.error('Error saving column visibility to localStorage:', error)
	}
}

/**
 * Remove column visibility state for a specific quote ID from localStorage
 */
export const removeColumnVisibilityForQuote = (quoteId: string): void => {
	try {
		const storedData = localStorage.getItem(COLUMN_VISIBILITY_STORAGE_KEY)
		if (!storedData) {
			return
		}

		const allColumnVisibility: ColumnVisibilityState =
			JSON.parse(storedData)
		delete allColumnVisibility[quoteId]
		localStorage.setItem(
			COLUMN_VISIBILITY_STORAGE_KEY,
			JSON.stringify(allColumnVisibility)
		)
	} catch (error) {
		console.error(
			'Error removing column visibility from localStorage:',
			error
		)
	}
}

/**
 * Get all column visibility states from localStorage
 */
export const getAllColumnVisibility = (): ColumnVisibilityState => {
	try {
		const storedData = localStorage.getItem(COLUMN_VISIBILITY_STORAGE_KEY)
		return storedData ? JSON.parse(storedData) : {}
	} catch (error) {
		console.error(
			'Error reading all column visibility from localStorage:',
			error
		)
		return {}
	}
}

// Prep column visibility
const PREP_COLUMN_VISIBILITY_STORAGE_KEY = 'prepQuoteColumnVisibility'

export const getPrepColumnVisibilityForQuote = (
	quoteId: string
): Record<string, boolean> => {
	try {
		const storedData = localStorage.getItem(
			PREP_COLUMN_VISIBILITY_STORAGE_KEY
		)
		if (!storedData) return {}
		const all: ColumnVisibilityState = JSON.parse(storedData)
		return all[quoteId] || {}
	} catch (error) {
		console.error(
			'Error reading prep column visibility from localStorage:',
			error
		)
		return {}
	}
}

export const savePrepColumnVisibilityForQuote = (
	quoteId: string,
	columnVisibility: Record<string, boolean>
): void => {
	try {
		const storedData = localStorage.getItem(
			PREP_COLUMN_VISIBILITY_STORAGE_KEY
		)
		let all: ColumnVisibilityState = {}
		if (storedData) all = JSON.parse(storedData)
		all[quoteId] = columnVisibility
		localStorage.setItem(
			PREP_COLUMN_VISIBILITY_STORAGE_KEY,
			JSON.stringify(all)
		)
	} catch (error) {
		console.error(
			'Error saving prep column visibility to localStorage:',
			error
		)
	}
}

// Wrap column visibility
const WRAP_COLUMN_VISIBILITY_STORAGE_KEY = 'wrapQuoteColumnVisibility'

export const getWrapColumnVisibilityForQuote = (
	quoteId: string
): Record<string, boolean> => {
	try {
		const storedData = localStorage.getItem(
			WRAP_COLUMN_VISIBILITY_STORAGE_KEY
		)
		if (!storedData) return {}
		const all: ColumnVisibilityState = JSON.parse(storedData)
		return all[quoteId] || {}
	} catch (error) {
		console.error(
			'Error reading wrap column visibility from localStorage:',
			error
		)
		return {}
	}
}

export const saveWrapColumnVisibilityForQuote = (
	quoteId: string,
	columnVisibility: Record<string, boolean>
): void => {
	try {
		const storedData = localStorage.getItem(
			WRAP_COLUMN_VISIBILITY_STORAGE_KEY
		)
		let all: ColumnVisibilityState = {}
		if (storedData) all = JSON.parse(storedData)
		all[quoteId] = columnVisibility
		localStorage.setItem(
			WRAP_COLUMN_VISIBILITY_STORAGE_KEY,
			JSON.stringify(all)
		)
	} catch (error) {
		console.error(
			'Error saving wrap column visibility to localStorage:',
			error
		)
	}
}
